import React, { useState, useEffect } from "react";
import { Charge } from "../../pages";
import { ChargeController } from "../../controllers";
import { toJS } from "mobx";
import { chargeStore } from "../../stores";

const ChargeContainer = () => {
    const [loading, setLoading] = useState(false);
    const [addChargeModal, setAddChargeModal] = useState(false);
    const [editChargeModal, setEditChargeModal] = useState(false);
    const [deleteChargeModal, setDeleteChargeModal] = useState(false);

    useEffect(() => {
        setLoading(true)
        const getChargeList = async () => {
            await Promise.all([
                ChargeController.getCharges(),
            ])
            setLoading(false);
        }
        getChargeList();
    }, []);
    const handleAddCharge = () => {
        setAddChargeModal(true);
    }

    const handleEditCharge = () => {
        setEditChargeModal(true);
    }

    const handleDeleteCharge = () => {
        setDeleteChargeModal(true);
    }

    const closeModal = () => {
        setAddChargeModal(false);
        setEditChargeModal(false);
        setDeleteChargeModal(false);
    }
    return (
        <Charge
            addChargeModal={addChargeModal}
            editChargeModal={editChargeModal}
            deleteChargeModal={deleteChargeModal}
            loading={loading}
            closeModal={closeModal}
            chargeList={toJS(chargeStore.charges)}
            handleAddCharge={handleAddCharge}
            handleEditCharge={handleEditCharge}
            handleDeleteCharge={handleDeleteCharge}
        />
    )
}
export default ChargeContainer;